import React from "react";
import { Avatar, Typography } from "antd";
const { Text } = Typography;
const Employee = (props) => {
  const { record } = props;
  const letter = record?.first_name?.charAt(0) || "";
  const name = record.surename + " " + record.first_name;

  return (
    <div>
      {record.avatar_url ? (
        <Avatar src={record.avatar_url} />
      ) : (
        <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
          {letter}
        </Avatar>
      )}
      <Text style={{ padding: "0 10px" }}>{name}</Text>
    </div>
  );
};

export default Employee;
